<template>
    <div class="modal show fitbase-modal-schedule-event" @click.self="$emit('close')">
        <div class="modal-dialog">
            <div class="modal-content fitbase-schedule-modal">

                <div v-if="loading" class="fitbase-schedule-modal__preloader">
                    <span class="fitbase-loader loader-spin"></span>
                </div>

                <template v-else-if="detail">

                    <!-- Шапка: название + крестик -->
                    <div class="fitbase-schedule-modal__head">
                        <div class="fitbase-schedule-modal__head-top">
                            <h3 class="fitbase-schedule-modal__title">{{ detail.name }}</h3>
                            <button class="fitbase-schedule-modal__close-btn" @click="$emit('close')">
                                <span class="fitbase-icon-primary" :style="{ maskImage: `url(${closeIcon})`, webkitMaskImage: `url(${closeIcon})` }" style="width:12px;height:12px;display:block"></span>
                            </button>
                        </div>
                        <div class="fitbase-schedule-modal__head-meta">
                            <div class="fitbase-schedule-modal__meta-items">
                                <span>{{ timeStart }}<template v-if="timeEnd"> – {{ timeEnd }}</template></span>
                                <span class="fitbase-schedule-modal__meta-dot">•</span>
                                <span>{{ formattedDate }}</span>
                                <template v-if="placeName">
                                    <span class="fitbase-schedule-modal__meta-dot">•</span>
                                    <span>{{ placeName }}</span>
                                </template>
                            </div>
                            <span
                                v-if="detail.status_label"
                                class="fitbase-schedule-badge"
                                :style="statusLabelStyle"
                            >{{ detail.status_label.text }}</span>
                        </div>
                    </div>

                    <!-- Тренер -->
                    <div class="fitbase-schedule-modal__trainer-card" v-if="trainers.length">
                        <div v-for="t in trainers" :key="t.id" class="fitbase-schedule-modal__trainer-row">
                            <div class="fitbase-schedule-modal__trainer-left">
                                <img v-if="t.photo" :src="t.photo" :alt="t.fio" class="fitbase-schedule-modal__trainer-photo">
                                <span v-else class="fitbase-schedule-modal__trainer-photo fitbase-schedule-modal__trainer-photo--no-photo">
                                    <img src="../assets/img/profile.svg" alt="" width="24" height="24">
                                </span>
                                <div class="fitbase-schedule-modal__trainer-info">
                                    <span class="fitbase-schedule-modal__trainer-name">{{ [t.name, t.surname].filter(Boolean).join(' ') }}</span>
                                    <span class="fitbase-schedule-modal__trainer-function" v-if="t.function">{{ t.function }}</span>
                                </div>
                            </div>
                            <div class="fitbase-schedule-modal__rating-pill" v-if="t.rating || t.review_count">
                                <div class="fitbase-schedule-modal__rating-score" v-if="t.rating">
                                    <img src="../assets/img/star2.svg" alt="" class="fitbase-schedule-modal__rating-star">
                                    <span>{{ t.rating }}</span>
                                </div>
                                <div class="fitbase-schedule-modal__rating-divider" v-if="t.rating && t.review_count"></div>
                                <div class="fitbase-schedule-modal__rating-reviews" v-if="t.review_count">{{ t.review_count }} {{ pluralOtzyvov(t.review_count) }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Панель записи -->
                    <div class="fitbase-schedule-modal__register-card" :class="{ 'fitbase-schedule-modal__register-card--success': resultMessage && resultType === 'success' }" v-if="detail.need_register && !registrationDisabled">

                        <div v-if="actionLoading" class="fitbase-schedule-modal__action-loading">
                            <span class="fitbase-loader loader-spin"></span>
                        </div>

                        <template v-else>

                            <!-- Результат -->
                            <div v-if="resultMessage" class="fitbase-schedule-modal__result" :class="resultType">
                                <div v-if="resultType === 'success'" class="fitbase-schedule-modal__result-banner">
                                    <div class="fitbase-schedule-modal__result-icon-wrap">
                                        <img src="../assets/img/white-check.svg" alt="">
                                    </div>
                                    <span class="fitbase-schedule-modal__result-banner-text">{{ resultMessage }}</span>
                                </div>
                                <div v-else class="fitbase-schedule-modal__result-text">{{ resultMessage }}</div>

                                <div v-if="resultType === 'success' && hasAppLinks" class="fitbase-schedule-modal__app-banner">
                                    <div class="fitbase-schedule-modal__app-banner-texts">
                                        <div class="fitbase-schedule-modal__app-banner-title">Удобнее в приложении</div>
                                        <div class="fitbase-schedule-modal__app-banner-subtitle">Записи, абонементы, расписание, тренеры и онлайн-оплата в одном месте</div>
                                    </div>
                                    <div class="fitbase-schedule-modal__app-banner-btns">
                                        <a v-if="appLinks.google_play && osType !== 'ios'" :href="appLinks.google_play" target="_blank">
                                            <img :src="isDark ? require('../assets/img/gp-dark.svg') : require('../assets/img/gp-white.svg')" alt="Google Play">
                                        </a>
                                        <a v-if="appLinks.apple_store && osType !== 'android'" :href="appLinks.apple_store" target="_blank">
                                            <img :src="isDark ? require('../assets/img/appstore-dark.svg') : require('../assets/img/appstore-white.svg')" alt="App Store">
                                        </a>
                                        <a v-if="appLinks.rustore && osType !== 'ios'" :href="appLinks.rustore" target="_blank">
                                            <img :src="isDark ? require('../assets/img/rustore-dark.svg') : require('../assets/img/rustore-white.svg')" alt="RuStore">
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <template v-else>

                                <!-- Занятие отменено -->
                                <div v-if="isCancelled" class="fitbase-schedule-modal__register-status p20 fitbase-schedule-modal__register-status--closed ">
                                    Занятие отменено
                                </div>

                                <!-- Запись закрыта -->
                                <div v-else-if="isClosed && !detail.time_open" class="fitbase-schedule-modal__register-status p20 fitbase-schedule-modal__register-status--closed">
                                    Запись окончена
                                </div>

                                <!-- Запись ещё не открылась -->
                                <div v-else-if="isClosed && detail.time_open" class="fitbase-schedule-modal__register-status p20">
                                    Запись откроется {{ formatTimeOpen(detail.time_open) }}
                                </div>

                                <!-- Ожидает оплаты -->
                                <div v-else-if="isPendingPayment" class="fitbase-schedule-modal__register-status p20">
                                    Ожидает оплаты
                                </div>

                                <!-- Вы записаны / лист ожидания -->
                                <template v-else-if="isSigned || isWaiting">
                                    <div class="fitbase-schedule-modal__register-content">
                                        <div class="fitbase-schedule-modal__register-left">
                                            <div class="fitbase-schedule-modal__register-title">
                                                <span v-if="isSigned">Вы записаны!</span>
                                                <span v-if="isWaiting">Вы в листе ожидания</span>
                                            </div>
                                            <div class="fitbase-schedule-modal__register-subtitle" v-if="freeSlots !== null && !detail.hide_number_of_available_setting">
                                                Осталось: {{ freeSlots }} {{ pluralMesta(freeSlots) }}
                                            </div>
                                        </div>
                                        <div class="fitbase-schedule-modal__error fitbase-schedule-modal__error--left" v-if="registrationErrorMessage">{{ registrationErrorMessage }}</div>
                                        <div class="fitbase-schedule-modal__register-right">
                                            <button class="fitbase-schedule-modal__cancel-btn" @click="cancelRegistration">Отменить запись</button>
                                        </div>
                                    </div>
                                </template>

                                <!-- Есть свободные места -->
                                <template v-else-if="hasFreeSlots">
                                    <div class="fitbase-schedule-modal__register-content">
                                        <div class="fitbase-schedule-modal__register-left">
                                            <div class="fitbase-schedule-modal__register-title">Предварительная запись</div>
                                            <div class="fitbase-schedule-modal__register-subtitle" v-if="freeSlots !== null && !detail.hide_number_of_available_setting">
                                                Осталось: {{ freeSlots }} {{ pluralMesta(freeSlots) }}
                                            </div>
                                            <div class="fitbase-schedule-modal__register-subtitle" v-if="freeSlots !== null && detail.hide_number_of_available_setting">
                                                Места есть
                                            </div>
                                        </div>
                                        <div class="fitbase-schedule-modal__error fitbase-schedule-modal__error--left" v-if="registrationErrorMessage">{{ registrationErrorMessage }}</div>
                                        <div class="fitbase-schedule-modal__register-right">

                                            <!-- Гость, без visit reason -->
                                            <template v-if="!isAuthenticated && !detail.require_visit_reason">
                                                <div class="fitbase-schedule-modal__form-row">
                                                    <vue-tel-input
                                                        v-model="guestPhoneRaw"
                                                        class="fitbase-schedule-modal__phone-input"
                                                        :default-country="defaultCountry"
                                                        :input-options="phoneInputOptions"
                                                        :preferred-countries="preferredCountries"
                                                        @validate="phoneValidation"
                                                        @country-changed="onCountryChanged"
                                                    ></vue-tel-input>
                                                    <button class="fitbase-schedule-modal__register-btn" :disabled="!phoneValid" @click="registerGuest">Записаться</button>
                                                </div>
                                                <div class="fitbase-schedule-modal__agreement" v-html="agreeText"></div>
                                            </template>

                                            <!-- Залогинен -->
                                            <template v-else-if="isAuthenticated">
                                                <button
                                                    v-if="!errorMessage"
                                                    class="fitbase-schedule-modal__register-btn"
                                                    @click="handleRegistrationClick"
                                                >Записаться</button>
                                            </template>

                                            <!-- Гость + visit reason -->
                                            <template v-else>
                                                <button class="fitbase-schedule-modal__register-btn" @click="pendingAction = 'handleRegisterWithReason'; showAuthModal = true">Записаться</button>
                                            </template>
                                        </div>
                                    </div>
                                </template>

                                <!-- Мест нет -->
                                <template v-else>
                                    <div class="fitbase-schedule-modal__register-content">
                                        <div class="fitbase-schedule-modal__register-left">
                                            <div class="fitbase-schedule-modal__register-title">Мест нет</div>
                                            <div class="fitbase-schedule-modal__register-subtitle">Запишитесь в лист ожидания</div>
                                        </div>
                                        <div class="fitbase-schedule-modal__error fitbase-schedule-modal__error--left" v-if="registrationErrorMessage">{{ registrationErrorMessage }}</div>
                                        <div class="fitbase-schedule-modal__register-right">

                                            <template v-if="!detail.require_visit_reason">
                                                <template v-if="!isAuthenticated">
                                                    <div class="fitbase-schedule-modal__form-row">
                                                        <vue-tel-input
                                                            v-model="guestPhoneRaw"
                                                            class="fitbase-schedule-modal__phone-input"
                                                            :default-country="defaultCountry"
                                                            :input-options="phoneInputOptions"
                                                            :preferred-countries="preferredCountries"
                                                            @validate="phoneValidation"
                                                            @country-changed="onCountryChanged"
                                                        ></vue-tel-input>
                                                        <button class="fitbase-schedule-modal__register-btn" :disabled="!phoneValid" @click="registerGuest">В лист ожидания</button>
                                                    </div>
                                                    <div class="fitbase-schedule-modal__agreement" v-html="agreeText"></div>
                                                </template>
                                                <template v-else>
                                                    <button class="fitbase-schedule-modal__register-btn" @click="handleRegistrationClick">В лист ожидания</button>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="!isAuthenticated">
                                                    <button class="fitbase-schedule-modal__register-btn" @click="pendingAction = 'handleRegisterWithReason'; showAuthModal = true">Войти и записаться</button>
                                                </template>
                                                <template v-else>
                                                    <button class="fitbase-schedule-modal__register-btn" @click="handleRegistrationClick">Купить и записаться</button>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </template>

                            </template>
                        </template>
                    </div>

                    <!-- Теги: По записи / Платное -->
                    <div class="fitbase-schedule-modal__tags" v-if="(detail.need_register || detail.payed === 'pay') && !(resultMessage && resultType === 'success')">
                        <span v-if="detail.need_register" class="fitbase-schedule-modal__tag">
                            <span class="fitbase-schedule-modal__tag-icon fitbase-icon-primary" :style="iconMask(editBlueIcon)"></span>
                            По записи
                        </span>
                        <span v-if="detail.payed === 'pay'" class="fitbase-schedule-modal__tag">
                            <span class="fitbase-schedule-modal__tag-icon fitbase-icon-primary" :style="iconMask(walletBlueIcon)"></span>
                            Платная
                        </span>
                    </div>

                    <!-- Описание -->
                    <div class="fitbase-schedule-modal__description" v-if="detail.description && !(resultMessage && resultType === 'success')">
                        <template v-if="isDescriptionLong && !descriptionExpanded">
                            <span v-html="truncatedDescription"></span><span class="fitbase-schedule-modal__description-ellipsis"></span><button class="fitbase-schedule-modal__read-more" @click="descriptionExpanded = true">Читать подробнее</button>
                        </template>
                        <div v-else v-html="detail.description"></div>
                    </div>

                    <!-- Медиа-галерея -->
                    <div class="fitbase-schedule-modal__media" v-if="mediaItems.length > 0 && !(resultMessage && resultType === 'success')">
                        <div class="fitbase-schedule-modal__media-scroll">
                            <div
                                v-for="(item, i) in mediaItems"
                                :key="i"
                                class="fitbase-schedule-modal__media-thumb"
                                @click="openLightbox(i)"
                            >
                                <img :src="item.thumb" alt="">
                                <div v-if="item.type === 'video'" class="fitbase-schedule-modal__media-play">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.45)"/><path d="M10 8.5L16 12L10 15.5V8.5Z" fill="#fff"/></svg>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
            </div>
        </div>
    </div>

    <!-- Лайтбокс -->
    <div
        v-if="lightboxIndex !== null"
        class="fitbase-schedule-lightbox"
        @click.self="closeLightbox"
        @keydown.esc="closeLightbox"
        tabindex="0"
        ref="lightbox"
    >
        <button class="fitbase-schedule-lightbox__close" @click="closeLightbox">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 2L18 18M18 2L2 18" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
        </button>

        <div v-if="currentLightboxItem.type === 'video'" class="fitbase-schedule-lightbox__video-wrap">
            <iframe
                :src="currentLightboxItem.url"
                class="fitbase-schedule-lightbox__iframe"
                frameborder="0"
                allowfullscreen
                allow="autoplay; fullscreen"
            ></iframe>
        </div>

        <img
            v-else
            :src="currentLightboxItem.url"
            class="fitbase-schedule-lightbox__img"
            @click.stop
        >

        <button
            v-if="lightboxIndex > 0"
            class="fitbase-schedule-lightbox__arrow fitbase-schedule-lightbox__arrow--prev"
            @click="lightboxIndex--"
        >
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none"><path d="M9 1L1 9L9 17" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <button
            v-if="lightboxIndex < mediaItems.length - 1"
            class="fitbase-schedule-lightbox__arrow fitbase-schedule-lightbox__arrow--next"
            @click="lightboxIndex++"
        >
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none"><path d="M1 1L9 9L1 17" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>

        <div class="fitbase-schedule-lightbox__dots" v-if="mediaItems.length > 1">
            <span
                v-for="(_, i) in mediaItems"
                :key="i"
                class="fitbase-schedule-lightbox__dot"
                :class="{ active: i === lightboxIndex }"
                @click="lightboxIndex = i"
            ></span>
        </div>
    </div>

    <auth-modal
        v-if="showAuthModal"
        @close="showAuthModal = false"
        @authenticated="onAuthSuccess"
        @no_client="onAuthNoClient"
    />

    <schedule-registration-flow-modal
        v-if="showRegistrationFlow && detail"
        :schedule-id="detail.id"
        :show-profile-tab="registrationFlowShowProfile"
        :initial-catalog="registrationFlowCatalog"
        :reasons="registrationFlowReasons"
        @close="showRegistrationFlow = false"
        @registered="onFlowRegistered"
        @insufficient-visits="onFlowInsufficientVisits"
        @restart="onFlowRestart"
    />
</template>

<script>
import moment from 'moment'
import closeIcon from '../assets/img/close.svg'
import editBlueIcon from '../assets/img/edit-blue.svg'
import walletBlueIcon from '../assets/img/wallet-blue.svg'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import AuthModal from './AuthModal.vue'
import ScheduleRegistrationFlowModal from './ScheduleRegistrationFlowModal.vue'

export default {
    name: 'ScheduleEventModal',
    components: { AuthModal, ScheduleRegistrationFlowModal, VueTelInput },
    props: {
        event: { type: Object, required: true },
        registrationDisabled: { type: Boolean, default: false },
        theme: { type: String, default: 'light' },
    },
    emits: ['close', 'refresh'],
    data() {
        return {
            closeIcon,
            editBlueIcon,
            walletBlueIcon,
            detail: null,
            loading: true,
            actionLoading: false,
            resultMessage: '',
            resultType: 'success',
            errorMessage: '',
            statusCheckError: '',
            guestPhone: '',
            guestPhoneRaw: '',
            phoneValid: false,
            currentDialCode: '7',
            phoneInputOptions: { placeholder: 'Ваш телефон' },
            showAuthModal: false,
            showRegistrationFlow: false,
            registrationFlowShowProfile: false,
            registrationFlowCatalog: [],
            registrationFlowReasons: [],
            pendingAction: null,
            lightboxIndex: null,
            descriptionExpanded: false,
        }
    },
    computed: {
        isAuthenticated() {
            return !!this.$store.state.token
        },
        defaultCountry() {
            const code = this.$store.getters.settings?.widget?.defaultCountry
            return String(code || 'RU').toUpperCase()
        },
        preferredCountries() {
            const fromSettings = this.$store.getters.settings?.widget?.preferredCountries
            const list = Array.isArray(fromSettings) && fromSettings.length
                ? fromSettings.map((code) => String(code).toUpperCase())
                : ['RU', 'BY', 'KZ', 'UZ', 'KG', 'AM', 'AZ', 'TJ', 'GE', 'ID']
            const priority = this.defaultCountry
            return [priority, ...list.filter((code) => code !== priority)]
        },
        registrationErrorMessage() {
            return this.errorMessage || this.statusCheckError
        },
        isDark() {
            return this.theme === 'dark'
        },
        appLinks() {
            return this.$store.getters.storeLinks || {}
        },
        hasAppLinks() {
            const l = this.appLinks
            return !!(l.google_play || l.apple_store || l.rustore)
        },
        osType() {
            const ua = navigator.userAgent
            console.log('[osType] userAgent:', ua)
            console.log('[osType] maxTouchPoints:', navigator.maxTouchPoints)
            if (/android/i.test(ua)) return 'android'
            if (/ipad|iphone|ipod/i.test(ua)) return 'ios'
            // iPadOS 13+ маскируется под Mac, но имеет тач
            if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios'
            return 'other'
        },
        formattedDate() {
            return moment(this.detail.date, 'YYYY-MM-DD').format('dd, D MMMM')
        },
        timeStart() {
            return moment(this.detail.time_start, 'HH:mm:ss').format('HH:mm')
        },
        timeEnd() {
            if (!this.detail.time_end || this.detail.time_end === '00:00:00') return ''
            return moment(this.detail.time_end, 'HH:mm:ss').format('HH:mm')
        },
        duration() {
            if (!this.detail.time_start || !this.detail.time_end || this.detail.time_end === '00:00:00') return null
            const start = moment(this.detail.time_start, 'HH:mm:ss')
            const end = moment(this.detail.time_end, 'HH:mm:ss')
            const diff = end.diff(start, 'minutes')
            return diff > 0 ? diff : null
        },
        trainers() {
            if (this.detail.trainers && this.detail.trainers.length) {
                return this.detail.trainers.map(t => t.replacement || t)
            }
            const t = this.detail.trainer_replacement || this.detail.trainer
            if (!t) return []
            return [{ ...t, fio: [t.surname, t.name].filter(Boolean).join(' ') }]
        },
        placeName() {
            const p = this.detail.place
            if (!p) return ''
            return typeof p === 'object' ? p.name : p
        },
        isCancelled() {
            return this.detail.status === 'cancel' || this.detail.cancel === 1
        },
        isClosed() {
            return this.detail.status === 'closed' || this.detail.status === 'temporarily_closed'
        },
        isSigned() {
            return this.detail.status === 'signed'
        },
        isPendingPayment() {
            return this.detail.status === 'pending_payment'
        },
        isWaiting() {
            return this.detail.status === 'waiting'
        },
        statusLabelStyle() {
            const s = this.detail.status
            if (s === 'signed') return { backgroundColor: '#4EB410', color: '#FFFFFF' }
            if (s === 'cancel') return { backgroundColor: '#ED3D3D', color: '#FFFFFF' }
            if (s === 'transfer') return { backgroundColor: '#F19819', color: '#FFFFFF' }
            if (s === 'available' && this.freeSlots === 1) return { backgroundColor: '#F19819', color: '#FFFFFF' }
            return { backgroundColor: '#9898A5', color: '#FFFFFF' }
        },
        freeSlots() {
            if (!this.detail.records_limit || this.detail.records_limit === 0) return null
            return this.detail.records_limit - (this.detail.records_current || 0)
        },
        hasFreeSlots() {
            if (!this.detail.records_limit || this.detail.records_limit === 0) return true
            return this.freeSlots > 0
        },
        clubId() {
            const source = this.detail || this.event
            return source?.club?.id || null
        },
        isDescriptionLong() {
            return this.detail && this.detail.description && this.detail.description.length > 220
        },
        truncatedDescription() {
            if (!this.detail || !this.detail.description) return ''
            return this.detail.description.slice(0, 220).trimEnd()
        },
        mediaItems() {
            if (!this.detail) return []
            const items = []
            for (const v of (this.detail.videos || [])) {
                items.push({ type: 'video', url: v.url, thumb: this.fullUrl(v.preview) })
            }
            for (const img of (this.detail.images || [])) {
                items.push({ type: 'image', url: this.fullUrl(img), thumb: this.fullUrl(img) })
            }
            return items
        },
        currentLightboxItem() {
            return this.lightboxIndex !== null ? this.mediaItems[this.lightboxIndex] : null
        },
        agreeText() {
            try {
                const settings = this.$store.getters.documentsModules || {}
                let personalDataText = 'Обработкой персональных данных'
                if (settings.processing_personal_data?.enable && settings.processing_personal_data.link) {
                    personalDataText = `<a href="${settings.processing_personal_data.link}" target="_blank">Обработкой персональных данных</a>`
                }
                let offerText = 'Офертой'
                if (settings.offer?.enable && settings.offer.link) {
                    offerText = `<a href="${settings.offer.link}" target="_blank">Офертой</a>`
                }
                let clubRulesText = 'Правилами клуба'
                if (settings.club_rules?.enable && settings.club_rules.link) {
                    clubRulesText = `<a href="${settings.club_rules.link}" target="_blank">Правилами клуба</a>`
                }
                return `Продолжая, вы соглашаетесь с ${personalDataText}, ${offerText} и ${clubRulesText}.`
            } catch (e) {
                return ''
            }
        },
    },
    watch: {
        detail() {
            this.descriptionExpanded = false
        },
        '$store.state.scheduleRegistrationResult'(val) {
            if (val && this.detail && val.scheduleId === this.detail.id) {
                this.resultMessage = val.message
                this.resultType = val.success ? 'success' : 'error'
                this.$store.commit('SET_SCHEDULE_REGISTRATION_RESULT', null)
                this.fetchDetail()
            }
        },
        guestPhoneRaw(val) {
            if (typeof val === 'string' && val.charAt(0) === '8' && this.currentDialCode === '7') {
                this.guestPhoneRaw = '+7' + val.slice(1)
            }
        },
    },
    methods: {
        formatTimeOpen(timeOpen) {
            if (!timeOpen) return ''
            return moment(timeOpen, 'YYYY-MM-DD HH:mm:ss').format('D MMMM в HH:mm')
        },
        iconMask(src) {
            return { maskImage: `url(${src})`, webkitMaskImage: `url(${src})` }
        },
        phoneValidation(phone) {
            this.phoneValid = !!phone?.valid
            this.guestPhone = this.phoneValid
                ? `+${phone.countryCallingCode}${phone.nationalNumber}`
                : ''
        },
        onCountryChanged(country) {
            this.currentDialCode = country?.dialCode || ''
        },
        pluralMesta(n) {
            if (n === 1) return 'место'
            if (n >= 2 && n <= 4) return 'места'
            return 'мест'
        },
        pluralOtzyvov(n) {
            const mod10 = n % 10
            const mod100 = n % 100
            if (mod100 >= 11 && mod100 <= 14) return 'отзывов'
            if (mod10 === 1) return 'отзыв'
            if (mod10 >= 2 && mod10 <= 4) return 'отзыва'
            return 'отзывов'
        },
        fullUrl(path) {
            if (!path) return ''
            if (path.startsWith('http')) return path
            return path
        },
        openLightbox(index) {
            this.lightboxIndex = index
            this.$nextTick(() => this.$refs.lightbox && this.$refs.lightbox.focus())
        },
        closeLightbox() {
            this.lightboxIndex = null
        },
        async onAuthSuccess() {
            this.showAuthModal = false
            await this.fetchDetail()
            if (this.pendingAction) {
                const action = this.pendingAction
                this.pendingAction = null
                if (action === 'handleRegisterWithReason' || action === 'register') {
                    this.handleRegistrationClick()
                }
            }
        },
        async onAuthNoClient({ phone, token }) {
            if (token) {
                localStorage.setItem('fitbase_token', token)
            }

            try {
                const clubId = this.clubId
                await this.$api.auth.registration({
                    name: 'без данных',
                    surname: 'Клиент',
                    patronymic: '',
                    b_day: '',
                    phone: phone,
                    club: clubId,
                })
            } catch (e) { /* silent */ }
            // Теперь устанавливаем токен в store — loadUser найдёт готового клиента
            if (token) {
                this.$store.commit('SET_TOKEN', token)
            }
            try {
                await this.fetchDetail()
                const response = await this.$api.schedule.getScheduleReasons(this.detail.id)
                const catalog = response.data.catalog || []
                this.registrationFlowCatalog = catalog
            } catch (e) { /* silent */ }
            this.registrationFlowShowProfile = true
            this.showRegistrationFlow = true
        },
        onFlowRegistered(message) {
            this.showRegistrationFlow = false
            this.resultMessage = message
            this.resultType = 'success'
            this.$emit('refresh')
            this.fetchDetail()
        },
        onFlowInsufficientVisits(msg) {
            this.showRegistrationFlow = false
            this.errorMessage = msg
        },
        async onFlowRestart() {
            this.showRegistrationFlow = false
            await this.handleRegistrationClick()
        },
        async handleRegistrationClick() {
            this.actionLoading = true
            this.errorMessage = ''
            this.statusCheckError = ''

            try {
                await this.syncCurrentClubForEvent()

                const response = await this.$api.schedule.getSchedule(this.detail.id)
                this.detail = response.data

                if (this.isPendingPayment) {
                    return
                }

                if (this.isSigned || this.isWaiting || this.isCancelled || this.isClosed) {
                    return
                }

                if (this.detail.require_visit_reason) {
                    await this.handleRegisterWithReason()
                } else {
                    await this.register()
                }
            } catch (e) {
                const errData = e.response && e.response.data
                this.statusCheckError = (errData && errData.message) || 'Не удалось проверить статус занятия'
            } finally {
                this.actionLoading = false
            }
        },
        async fetchDetail() {
            this.loading = true
            try {
                const response = await this.$api.schedule.getSchedule(this.event.id)
                this.detail = response.data
            } catch (e) {
                this.detail = this.event
            } finally {
                this.loading = false
            }
        },
        async syncCurrentClubForEvent() {
            const clubId = this.clubId
            if (!clubId || !this.isAuthenticated) {
                return
            }

            if (Number(this.$store.state.user?.current_club) === Number(clubId)) {
                return
            }

            try {
                const result = await this.$api.user.changeCurrentClub(clubId)
                if (result.data?.status === 'success') {
                    await this.$store.dispatch('loadUser')
                }
            } catch (e) { /* silent */ }
        },
        async handleRegisterWithReason() {
            this.actionLoading = true
            this.errorMessage = ''
            try {
                await this.syncCurrentClubForEvent()
                await this.$api.schedule.postRegistrationCheck(this.detail.id)
                const response = await this.$api.schedule.getScheduleReasons(this.detail.id)
                const myReasons = response.data.my_reasons || []
                const catalog = response.data.catalog || []

                if (myReasons.length === 1) {
                    const reason = myReasons[0]
                    const params = {}
                    if (reason.type === 'contract') {
                        params.client_contract_id = parseInt(reason.id.replace('contract_', ''))
                    } else {
                        params.client_service_id = parseInt(reason.id.replace('service_', ''))
                    }
                    await this.register(params)
                } else if (myReasons.length === 0 && catalog.length > 0) {
                    this.registrationFlowCatalog = catalog
                    this.registrationFlowShowProfile = false
                    this.showRegistrationFlow = true
                } else {
                    this.registrationFlowReasons = myReasons
                    this.registrationFlowCatalog = catalog
                    this.registrationFlowShowProfile = false
                    this.showRegistrationFlow = true
                }
            } catch (e) {
                const errData = e.response && e.response.data
                this.errorMessage = (errData && errData.message)
                    || (Array.isArray(errData) ? errData.join(', ') : null)
                    || 'Ошибка при загрузке оснований для записи'
            } finally {
                this.actionLoading = false
            }
        },
        async register(extraParams = {}) {
            this.actionLoading = true
            this.errorMessage = ''
            try {
                const response = await this.$api.schedule.postRegistration(this.detail.id, extraParams)
                const data = response.data || {}
                if (data.status === 'need_select_reason') {
                    this.errorMessage = 'Недостаточно посещений для записи. Приобретите абонемент или услугу'
                    return
                }

                if (data.status === 'waiting') {
                    this.resultMessage = 'Вы добавлены в лист ожидания!'
                } else {
                    this.resultMessage = 'Вы успешно записаны'
                }

                this.resultType = 'success'
                this.$emit('refresh')
                await this.fetchDetail()
            } catch (e) {
                const errData = e.response && e.response.data
                this.errorMessage = (errData && errData.message)
                    || (Array.isArray(errData) ? errData.join(', ') : null)
                    || 'Ошибка при записи на занятие'
            } finally {
                this.actionLoading = false
            }
        },
        async registerGuest() {
            if (!this.guestPhone) return
            this.actionLoading = true
            this.errorMessage = ''
            try {
                const response = await this.$api.schedule.postGuestRegistration(
                    this.detail.id,
                    this.guestPhone,
                    this.clubId
                )
                const data = response.data || {}
                if (data.status === 'failed') {
                    this.errorMessage = data.message || 'Ошибка при записи'
                } else if (data.status === 'waiting') {
                    this.resultMessage = 'Вы добавлены в лист ожидания!'
                    this.resultType = 'success'
                } else {
                    this.resultMessage = 'Вы успешно записаны!'
                    this.resultType = 'success'
                }
            } catch (e) {
                const errData = e.response && e.response.data
                this.errorMessage = (errData && errData.message)
                    || (Array.isArray(errData) ? errData.join(', ') : null)
                    || 'Ошибка при записи'
            } finally {
                this.actionLoading = false
            }
        },
        async cancelRegistration() {
            this.actionLoading = true
            this.errorMessage = ''
            try {
                await this.$api.schedule.deleteRegistration(this.detail.sign_id)
                this.resultMessage = 'Запись отменена'
                this.resultType = 'fitbase-cancelled'
                this.$emit('refresh')
                await this.fetchDetail()
            } catch (e) {
                const errData = e.response && e.response.data
                this.errorMessage = (errData && (errData.message || errData.error))
                    || 'Ошибка при отмене записи'
            } finally {
                this.actionLoading = false
            }
        },
    },
    mounted() {
        document.body.classList.add('modal-open')
        this.fetchDetail()
    },
    unmounted() {
        if (document.querySelectorAll('.modal.show').length === 0) {
            document.body.classList.remove('modal-open')
        }
    },
}
</script>
